import { useEffect } from 'react'
import { useShallow } from 'zustand/react/shallow'

import { FilterableTable } from '@/components/table/base'
import { TitleSetter } from '@/components/Title'
import { usePlayers } from '@/stores/players'

import {
  STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS,
  STANDARIZED_GOLF_PLAYERS_TABLE_FILTERS
} from '../standarizedGolfPlayer.table'

export const PlayersTableView = () => {
  const {
    data,
    isLoading,
    isFetching,
    fetchData,
    resetState,
    pagination,
    setPagination,
    filters,
    setFilters
  } = usePlayers(
    useShallow((state) => ({
      data: state.data,
      isLoading: state.status === 'loading',
      isFetching: state.status === 'fetching',
      fetchData: state.fetchData,
      resetState: state.resetState,
      pagination: state.pagination,
      setPagination: state.setPagination,
      filters: state.filters,
      setFilters: state.setFilters
    }))
  )

  useEffect(() => {
    fetchData()
    return resetState
  }, [])

  return (
    <>
      <TitleSetter title="Golf - Players" />
      <FilterableTable
        columns={STANDARIZED_GOLF_PLAYERS_TABLE_COLUMNS}
        filters={STANDARIZED_GOLF_PLAYERS_TABLE_FILTERS}
        data={data}
        loading={isLoading}
        disableColumnVisibility
        fetching={isFetching}
        pagination={pagination}
        onPaginationChange={setPagination}
        onFiltersChange={setFilters}
        selectedFilters={filters}
      />
    </>
  )
}
